import React from 'react';
import { useSelector } from 'react-redux';
import { GenAIModal, OriginalAsset } from '@bynder/image-gen-frontend-lib';
import { useTranslate } from '@bynder/localization';
import useAccessRights from 'packages/hooks/useAccessRights';
import { getBynderAccessToken } from 'packages/store/platform/platform.selectors';
import features from '~/configs/features';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSave: ({ enhancementId, fileId }: { enhancementId: number; fileId: string }) => Promise<void>;
    sessionId: string;
    originalAsset: OriginalAsset;
    collectionId?: string;
}

export default function ImageGen({ isOpen, onClose, onSave, sessionId, originalAsset }: Props) {
    const { isPlatformAllowed } = useAccessRights();
    const { translate } = useTranslate();
    const token = useSelector(getBynderAccessToken);

    const isEnabled = isPlatformAllowed([features.EDIT_WITH_AI]);

    if (!isEnabled) {
        return null;
    }

    const getJWT = async () => {
        const testToken = localStorage.getItem('testGenAIToken');

        if (testToken) {
            return testToken;
        }

        return token;
    };

    const getJWTForUCV = async () => {
        return token;
    };

    const hostURL = () => {
        const testHostURL = localStorage.getItem('testGenAIHostURL');

        if (testHostURL) {
            return testHostURL;
        }

        // with trim last slash if exists
        return window.document.referrer.replace(/\/$/, '') || 'localhost';
    };

    const ucvHostURL = () => {
        const referrer = window.document.referrer;

        if (referrer.includes('localhost')) {
            return 'https://dam.bynder.com';
        }

        // with trim last slash if exists
        return window.document.referrer.replace(/\/$/, '') || 'localhost';
    };

    return (
        <GenAIModal
            getJWT={getJWT}
            getJWTForUCV={getJWTForUCV}
            originalAsset={originalAsset}
            sessionId={sessionId}
            isOpen={isOpen}
            onClose={onClose}
            onSave={onSave}
            allowedTools={['REMOVE_BACKGROUND', 'REPLACE_BACKGROUND', 'RESIZE', 'SMART_EDIT']}
            saveButtonLabel={translate('image-gen.modal.save')}
            isDownloadAvailable
            hostURL={hostURL()}
            ucvHostURL={ucvHostURL()}
            clientName="STUDIO"
        />
    );
}
